// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"417594c4","73":"01688f16","177":"5459ca05","183":"01688f16","398":"01688f16","475":"52fad8a6","921":"01688f16"}[chunkId] + ".chunk.css";
};